var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: { breadcrumbs: [{ name: "求人確認" }], title: "掲載前の求人" },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "section",
          [
            _c("job-publish-section-title", {
              attrs: {
                title: "求人情報プレビュー",
                description:
                  "修正に関するコメント、制作担当とのメッセージ確認は「求人」ボタンからご確認ください。",
              },
            }),
            _vm._v(" "),
            _c("job-pre-published-jobs", {
              attrs: {
                jobs: _vm.jobOption.jobList,
                "photoclip-ids": _vm.jobOption.photoclipIdList,
                "interview-ids": _vm.jobOption.interviewIdList,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "margin-top-1" },
          [
            _c("job-publish-section-title", {
              attrs: { title: "企業情報プレビュー" },
            }),
            _vm._v(" "),
            _c("job-pre-published-company", {
              attrs: { company: _vm.company },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid-x align-justify" }, [
      _c("div", { staticClass: "medium-9 cell" }, [
        _c("p", [_vm._v("掲載前の求人を確認します。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }